import EnhancedNextImage from 'components/helpers/Atoms/EnhancedNextImage/EnhancedNextImage';
import { TipShot } from 'lib/services/models/content-response';
import styles from './RecipeTipShot.module.scss';

export interface RecipeTipShotProps {
  tipShot?: TipShot;
}

export function RecipeTipShot({ tipShot }: RecipeTipShotProps) {
  if (!tipShot) {
    return <></>;
  }
  return (
    <EnhancedNextImage
      src={tipShot.Url}
      alt={tipShot.Name}
      fill
      className={styles.recipeTipShotImage}
    />
  );
}

export default RecipeTipShot;
